// Send to device → Suunto. Suunto's sign-in can't run in a popup the way Garmin's does, so a user
// who hasn't connected yet goes through the Integrations connect flow and is brought back here.

const CONNECT_PATH = '/user/suunto_connect';

// Where to send the user to connect Suunto, returning them to `returnTo` (a path on this site)
// once they have.
export function suuntoConnectUrl(returnTo: string): string {
  const safeReturnTo = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/';
  return `${CONNECT_PATH}?return_to=${encodeURIComponent(safeReturnTo)}`;
}
